import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useModalContainer } from './MessagingProvider';

const modalRoot = () => document.getElementById('sendbird-modal-root') as HTMLDivElement;

export const MessagingModal = ({ children, open }: { open: boolean; children: ReactNode }) => {
    const container = useModalContainer();

    if (!open) return null;

    // When a modal container ref is provided (student network), portal into it
    if (container) {
        return createPortal(<div className="absolute inset-0 z-[10000]">{children}</div>, container);
    }

    // Default: portal into Sendbird's modal root (widget)
    return createPortal(
        <div className="absolute left-0 top-0 z-[10000] flex h-full w-full items-center justify-center rounded-5">
            {children}
        </div>,
        modalRoot(),
    );
};
